import { apiDocsFr } from './apiDocs';
import { catalogFr } from './catalog';
import { catalogGraphFr } from './catalogGraph';
import { catalogReactFr } from './catalogReact';
import { coreComponentsFr } from './coreComponents';
import { orgFr } from './org';
import { scaffolderFr } from './scaffolder';
import { scaffolderReactFr } from './scaffolderReact';
import { searchFr } from './search';
import { searchReactFr } from './searchReact';
import { userSettingsFr } from './userSettings';

export const frTranslationResources = [
  apiDocsFr,
  catalogFr,
  catalogGraphFr,
  catalogReactFr,
  coreComponentsFr,
  orgFr,
  scaffolderFr,
  scaffolderReactFr,
  searchFr,
  searchReactFr,
  userSettingsFr,
];
